import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ADMIN_API } from '../../common/common'
import { Logout } from '../../common/Funcation'
import ImageUpload from '../../components/ImageUpload'
import { postApi, notifyMessage, notifyError } from '../../service'
import InPageLoader from '../../components/InPlageLoader'

const EMPTY_FORM = {
  casinoId: '',
  title: '',
  name: '',
  picture: '',
  videoLink: '',
  apiUrl: '',
  streamUrl: '',
  category: 'casino',
  type: 'live casino',
  status: true,
  minBet: 1,
  maxBet: 10000,
  sortOrder: 0,
}

function ManageCasino() {
  const navigate = useNavigate()
  const [pageData, setPageData] = useState<any>({})
  const [showModal, setShowModal] = useState(false)
  const [editId, setEditId] = useState<string | null>(null)
  const [formData, setFormData] = useState<any>({ ...EMPTY_FORM })
  const [saving, setSaving] = useState(false)
  const [isLoader, setLoader] = useState(false)

  useEffect(() => {
    getPageData()
  }, [])

  const getPageData = async () => {
    setLoader(true)
    let data: any = {
      api: ADMIN_API.SETTING.MANAGE_CASINO.GET_LIST,
      value: {},
    }
    await postApi(data).then((response) => {
      setPageData(response.data.data)
      setLoader(false)
    }).catch((err) => {
      setLoader(false)
      if (err?.response?.data?.statusCode === 401) { Logout(); navigate('/login') }
    })
  }

  const openAddModal = () => {
    setEditId(null)
    setFormData({ ...EMPTY_FORM })
    setShowModal(true)
  }

  const openEditModal = async (id: string) => {
    const data: any = {
      api: ADMIN_API.SETTING.MANAGE_CASINO.GET_ONE,
      value: { id },
    }
    await postApi(data).then((response) => {
      const d = response.data.data
      setFormData({
        casinoId: d.casinoId || '',
        title: d.title || '',
        name: d.name || '',
        picture: d.picture || '',
        videoLink: d.videoLink || '',
        apiUrl: d.apiUrl || '',
        streamUrl: d.streamUrl || '',
        category: d.category || 'casino',
        type: d.type || 'live casino',
        status: d.status,
        minBet: d.minBet || 1,
        maxBet: d.maxBet || 10000,
        sortOrder: d.sortOrder || 0,
      })
      setEditId(id)
      setShowModal(true)
    }).catch(() => notifyError('Failed to load casino'))
  }

  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target
    setFormData((prev: any) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleImageUpload = (path: string) => {
    setFormData((prev: any) => ({ ...prev, picture: path }))
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setSaving(true)
    try {
      if (editId) {
        await postApi({
          api: ADMIN_API.SETTING.MANAGE_CASINO.UPDATE,
          value: { id: editId, ...formData },
        })
        notifyMessage('Casino updated successfully')
      } else {
        await postApi({
          api: ADMIN_API.SETTING.MANAGE_CASINO.CREATE,
          value: formData,
        })
        notifyMessage('Casino created successfully')
      }
      setShowModal(false)
      getPageData()
    } catch (err: any) {
      notifyError(err?.response?.data?.message || 'Something went wrong')
    } finally {
      setSaving(false)
    }
  }

  const toggleStatus = async (id: string, currentStatus: boolean) => {
    try {
      await postApi({
        api: ADMIN_API.SETTING.MANAGE_CASINO.TOGGLE_STATUS,
        value: { id, status: !currentStatus },
      })
      notifyMessage(`Casino ${!currentStatus ? 'activated' : 'deactivated'}`)
      getPageData()
    } catch {
      notifyError('Failed to update status')
    }
  }

  const apiBase = process.env.REACT_APP_API_ENDPOINT || ''
  const imageBase = apiBase.replace('/admin/', '/').replace('admin/', '')

  return (
    <div className="container settings">
      <div className="top_header">
        <div className="top_header_title mt-3 d_flex d_flex_justify_spacebt">
          <h5>Manage Casino Games</h5>
          <button className="btn btn-primary btn-sm" onClick={openAddModal}>
            + Add Casino
          </button>
        </div>
      </div>

      <table className="table01 margin-table">
        <thead>
          <tr className="light-grey-bg">
            <th>#</th>
            <th>Image</th>
            <th>Title</th>
            <th>Casino ID</th>
            <th>Category</th>
            <th>Min / Max Bet</th>
            <th>Sort</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {!isLoader && pageData?.results?.length > 0 ? pageData.results.map((item: any, i: number) => (
            <tr key={item._id}>
              <td>{i + 1}</td>
              <td style={{ width: '80px' }}>
                <img
                  src={item.picture?.startsWith('http') ? item.picture : `${imageBase}${item.picture}`}
                  alt={item.title}
                  style={{ width: '60px', height: '45px', objectFit: 'cover', borderRadius: '4px' }}
                  onError={(e: any) => { e.target.src = '' }}
                />
              </td>
              <td>
                <strong>{item.title}</strong>
                <div style={{ fontSize: '12px', color: '#888' }}>{item.name}</div>
              </td>
              <td><code>{item.casinoId}</code></td>
              <td>
                <span className="badge" style={{
                  background: '#e8f4fd', color: '#0089d7',
                  padding: '3px 8px', borderRadius: '4px', fontSize: '12px'
                }}>
                  {item.category}
                </span>
              </td>
              <td>{item.minBet} / {item.maxBet}</td>
              <td>{item.sortOrder}</td>
              <td>
                <button
                  className={`btn btn-sm ${item.status ? 'btn-success' : 'btn-danger'}`}
                  onClick={() => toggleStatus(item._id, item.status)}
                  style={{ minWidth: '60px' }}
                >
                  {item.status ? 'ON' : 'OFF'}
                </button>
              </td>
              <td>
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => openEditModal(item._id)}
                >
                  Edit
                </button>
              </td>
            </tr>
          )) : isLoader ? (
            <tr>
              <td colSpan={9} className="text-center" style={{ padding: '30px' }}>
                <InPageLoader />
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan={9} className="text-center" style={{ padding: '30px' }}>
                No casino games found. Click "+ Add Casino" to add one.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff', borderRadius: '8px', padding: '24px',
            width: '600px', maxHeight: '90vh', overflowY: 'auto',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
              <h5 style={{ margin: 0 }}>{editId ? 'Edit Casino' : 'Add New Casino'}</h5>
              <button
                onClick={() => setShowModal(false)}
                style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}
              >×</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-6 mb-3">
                  <label>Casino ID (URL slug) *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="casinoId"
                    value={formData.casinoId}
                    onChange={handleChange}
                    placeholder="e.g. lucky6, bollywood-casino-2"
                    required
                    disabled={!!editId}
                  />
                  <small className="text-muted">Unique ID, no spaces (cannot change after create)</small>
                </div>
                <div className="col-6 mb-3">
                  <label>Title *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Lucky 6"
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="LUCKY 6"
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Category</label>
                  <select className="form-control" name="category" value={formData.category} onChange={handleChange}>
                    <option value="casino">Casino</option>
                    <option value="lucky">Lucky</option>
                    <option value="teen-patti">Teen Patti</option>
                    <option value="roulette">Roulette</option>
                    <option value="andar-bahar">Andar Bahar</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="col-6 mb-3">
                  <label>Type</label>
                  <select className="form-control" name="type" value={formData.type} onChange={handleChange}>
                    <option value="live casino">Live Casino</option>
                    <option value="casino">Casino</option>
                  </select>
                </div>
                <div className="col-6 mb-3">
                  <label>Sort Order</label>
                  <input
                    type="number"
                    className="form-control"
                    name="sortOrder"
                    value={formData.sortOrder}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Min Bet *</label>
                  <input
                    type="number"
                    className="form-control"
                    name="minBet"
                    value={formData.minBet}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Max Bet *</label>
                  <input
                    type="number"
                    className="form-control"
                    name="maxBet"
                    value={formData.maxBet}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12 mb-3">
                  <label>Game Data API URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="apiUrl"
                    value={formData.apiUrl}
                    onChange={handleChange}
                    placeholder="https://api.provider.com/game/lucky6/round"
                  />
                </div>
                <div className="col-12 mb-3">
                  <label>Video Stream URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="streamUrl"
                    value={formData.streamUrl}
                    onChange={handleChange}
                    placeholder="https://stream.provider.com/lucky6"
                  />
                </div>
                <div className="col-12 mb-3">
                  <label>Thumbnail Image *</label>
                  <ImageUpload
                    setImage={handleImageUpload}
                    image={formData.picture}
                    folder="casino"
                  />
                  {formData.picture && (
                    <div style={{ marginTop: '8px' }}>
                      <input
                        type="text"
                        className="form-control"
                        name="picture"
                        value={formData.picture}
                        onChange={handleChange}
                        placeholder="Or paste image URL"
                      />
                    </div>
                  )}
                  {!formData.picture && (
                    <input
                      type="text"
                      className="form-control mt-2"
                      name="picture"
                      value={formData.picture}
                      onChange={handleChange}
                      placeholder="Or paste image URL directly"
                    />
                  )}
                </div>
                <div className="col-12 mb-3">
                  <label className="d_flex" style={{ gap: '10px', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      name="status"
                      checked={formData.status}
                      onChange={handleChange}
                    />
                    Active (show to users)
                  </label>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? 'Saving...' : editId ? 'Update Casino' : 'Create Casino'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ManageCasino
